import { render, staticRenderFns } from "./FunnelSettings.vue?vue&type=template&id=38fb5469&scoped=true"
import script from "./FunnelSettings.vue?vue&type=script&lang=js"
export * from "./FunnelSettings.vue?vue&type=script&lang=js"
import style0 from "./FunnelSettings.vue?vue&type=style&index=0&id=38fb5469&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fb5469",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38fb5469')) {
      api.createRecord('38fb5469', component.options)
    } else {
      api.reload('38fb5469', component.options)
    }
    module.hot.accept("./FunnelSettings.vue?vue&type=template&id=38fb5469&scoped=true", function () {
      api.rerender('38fb5469', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Activity/Elements/FunnelSettings.vue"
export default component.exports